// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import LocationInput from 'components/LocationInput';
import { setGMapsError } from '../redux/main/actions/gMapsError';

type OwnProps = {
  placeholder?: string,
  locationText: ?string,
  onChange: (?SearchLocation) => void,
  onEnter?: () => void,
  showClearButton: boolean,
  className?: string
};

type Props = {
  ...$Exact<OwnProps>,
  gMapsErrored: boolean,
  setGMapsError: Function
};

type State = {
  locationInputValue: string,
  prevPropsLocationText: ?string
};

class LocationInputContainer extends React.Component<Props, State> {
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    showClearButton: false
  };

  state = {
    locationInputValue: this.props.locationText || '',
    // eslint-disable-next-line react/no-unused-state
    prevPropsLocationText: this.props.locationText
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    // if the search location changes in the Redux store, update the
    // search input with the new value
    if (props.locationText !== state.prevPropsLocationText) {
      return {
        locationInputValue: props.locationText || '',
        prevPropsLocationText: props.locationText
      };
    }
    return null;
  }

  clearLocation = () => {
    this.setState({ locationInputValue: '' });
    this.props.onChange(null);
  };

  onLocationInputValueChange = (e: InputEvent) => {
    if (e.target.value === '') {
      this.clearLocation();
    }
    this.setState({ locationInputValue: e.target.value });
  };

  render() {
    const { locationText, onChange, className, ...inputProps } = this.props;
    return (
      <LocationInput
        {...inputProps}
        locationInputValue={this.state.locationInputValue}
        showClearButton={
          this.props.showClearButton && !!this.state.locationInputValue
        }
        clearLocation={this.clearLocation}
        onLocationChange={onChange}
        onLocationInputValueChange={this.onLocationInputValueChange}
        className={className}
      />
    );
  }
}

const mapStateToProps = ({ gMapsError: { errored } }) => ({
  gMapsErrored: errored
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  { setGMapsError }
)(LocationInputContainer);
